import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
      background: '#FFFFFF',
      borderRadius: '8px',
      padding: '0.4rem 0.5rem',
      gap: '0.5rem',
      height: '32px',
    },
    searchLabelText: {
      background: '#EDF0F4',
      borderRadius: '3px',
      width: '120px',
      textAlign: 'center',
      padding: '0.2rem 0',
      cursor: 'pointer',
    },
    searchInput: {
      background: 'transparent',
      border: 'transparent',
      outline: 'none',
      fontFamily: 'inherit',
      fontSize: '1rem',
    },
    dropdownContainer: {
      background: '#FFFFFF',
      borderRadius: '4px',
      padding: '1rem',
      position: 'absolute',
      zIndex: 200,
      top: '48px',
    },
    dropdownMenu: {
      display: 'flex',
      gap: '1rem',
      marginBottom: '0.8rem',
      cursor: 'pointer',
    },
    dropdownMenuLabel: {
      background: '#EDF0F4',
      borderRadius: '3px',
      width: '145px',
      height: '25px',
      textAlign: 'center',
    },
    infoContainer: {
      background: '#fff',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      padding: '1rem 1rem 0',
      gap: '0.6rem',
    },
    executionSummaryCont: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      alignItems: 'center',
      marginTop: '2rem',
      gap: '1rem',
    },
    channelSummaryCont: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px',
    },
    channelSummaryValue: {
      borderRight: '3px solid #e6e6e6',
      padding: '0 20px',
      fontSize: '1.4rem !important',
    },
    channelIvr: {
      padding: '0 20px',
      fontSize: '1.4rem !important',
    },
    cronVsRealCont: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.8rem',
      marginTop: '10px',

      '& p': {
        fontSize: '1.4rem !important',
        color: '#004357',
      },
    },
    cronVsRealSeparator: {
      height: '120%',
      background: '#004357',
      width: '2.5px',
    },
  })
);

export default useStyles;
